<template>
  <div class="chat-bot-input-cpn"
       :class="{disabled: isLock || isDefault}">
    <div class="input-area">
      <div class="textarea-area">
        <textarea class="chat-textarea"
                  id="chat-input"
                  :disabled="isLock || isDefault"
                  :placeholder="placeholder"
                  rows="2"
                  ref="chatTextarea"
                  v-model="inputValue"
                  @keyup.enter="enterPress"></textarea>
        <div class="chat-textarea-shadow"></div>
      </div>
      <div class="function-area">
        <div class="deepseek-btn"
             :class="{selected: deepthinkType}"
             @click="switchDeepthinkType">
          <img :src="deepthinkImg"
               style="width: 18px">
          DeepSeek 深度思考 ·R1
        </div>
        <!-- </el-tooltip> -->
        <template v-if="!showStop">
          <div class="send-btn"
               @click="sendClick">
            <i class="iconfont icon-fasong"
               :class="{disabled: isLock || isDefault}"></i>
          </div>
        </template>
        <template v-if="showStop">
          <el-tooltip class="item"
                      effect="dark"
                      content="停止生成"
                      placement="top">
            <div class="stop-btn"
                 @click="dialogVisible = true">
              <div class="stop-icon"></div>
            </div>
          </el-tooltip>
        </template>
      </div>
    </div>
    <el-tooltip class="item"
                effect="dark"
                placement="top">
      <div slot="content">
        <div style="margin-bottom: 10px">不知道怎么准确描述您的问题？</div>
        <div>可以<el-link @click="openHelpDialog"
                   style="color: white;text-decoration: underline;
    margin: 0 5px;
    vertical-align: text-top;">联系客服</el-link>获取专业帮助</div>
      </div>
      <i class="iconfont icon-question chat-help"
         v-show="showHelp"></i>
    </el-tooltip>
    <el-dialog title="提示"
               :visible.sync="dialogVisible"
               width="30%"
               :show-close="false">
      <span>确认停止生成当前问题吗？中途停止仍然会消耗提问额度</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false"
                   size="mini">取 消</el-button>
        <el-button type="primary"
                   @click="stopClick"
                   size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示"
               :visible.sync="dialogVisible"
               width="30%"
               :show-close="false">
      <span>确认停止生成当前问题吗？中途停止仍然会消耗提问额度</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false"
                   size="mini">取 消</el-button>
        <el-button type="primary"
                   @click="stopClick"
                   size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示"
               :visible.sync="answeringDialogVisible"
               width="40%"
               :show-close="true"
               style="">
      <span>您之前的提问正在生成回答～请在页面左侧会话列表查看状态为【等待用户反馈】或【回答中】的会话</span>
    </el-dialog>
  </div>
</template>


<script>
import { postUserHistory } from '@/api/public'
export default {
  name: 'InputCpn',
  data() {
    return {
      deepthinkImg: require('@/assets/deepthink-select.png'),
      deepthinkType: true,
      inputValue: '',
      placeholder: '向镜界提问市场数据/消费者评论/社媒热点...',
      showHelp: false,
      showStop: false,
      dialogVisible: false,
      answeringDialogVisible: false,
      sendLoading: false,
    }
  },
  props: {
    type: {
      default: '',
      type: String,
    },
    isLock: {
      default: false,
      type: Boolean,
    },
    homeDeepType: {
      default: '-1',
    },
    isDefault: {
      default: false,
      type: Boolean,
    },
    loginInfo: {
      default: null,
      type: Object,
    },
  },
  computed: {},
  methods: {
    stopClick() {
      this.$emit('stopCallbackFn')
      this.dialogVisible = false
    },
    switchDeepthinkType() {
      if (this.isLock || this.isDefault) {
        return
      }
      this.deepthinkType = !this.deepthinkType
      if (this.deepthinkType) {
        this.deepthinkImg = require('@/assets/deepthink-select.png')
      } else {
        this.deepthinkImg = require('@/assets/deepthink.png')
      }
    },
    async sendClick() {
      this.sendLoading = true
      if (this.isLock || this.isDefault) {
        return
      }
      if (!this.inputValue.trim()) {
        this.$message.warning('请输入问题')
        this.inputValue = ''
        return
      }
      if (this.loginInfo) {
        const isAnswering = await this.isAnsweringMethod()
        if (isAnswering) {
          this.answeringDialogVisible = true
          return
        }
      }
      this.$emit('inputCallback', this.inputValue.trim(), this.deepthinkType)
      this.inputValue = ''
      setTimeout(() => {
        this.sendLoading = false
      }, 1000)
    },
    isAnsweringMethod() {
      return postUserHistory().then((res) => {
        if (res.status == 'ok') {
          const result = res.result
          const data = result.data
          const isAnswering = data.find(
            (item) => item.status == 'answering' || item.status == 'waiting'
          )
          if (isAnswering) {
            return true
          } else {
            return false
          }
        }
      })
    },
    enterPress(e) {
      if (this.sendLoading) {
        return
      }
      // 如果按下 shift + enter,则允许换行
      if (e.shiftKey) {
        return
      }
      // 如果只按 enter,则阻止默认换行
      e.preventDefault()
      // 这里可以添加发送消息等其他处理逻辑
      this.sendClick()
    },
    openHelpDialog() {
      this.$emit('contact-event')
    },
    handleEnter(e) {},
  },
  created() {},
  mounted() {
    // setTimeout(() => {
    //   this.$refs.chatTextarea.focus()
    // }, 1000)
  },
  watch: {
    type: {
      handler(newVal, oldVal) {
        if (newVal == 'home') {
          this.placeholder = '使用上方模板向我提问'
        } else {
          this.placeholder = '向镜界提问市场数据/消费者评论/社媒热点...'
        }
      },
      immediate: true,
    },
    isLock(newVal) {
      this.showHelp = newVal
    },
    homeDeepType: {
      handler(newVal) {
        if (newVal != '-1') {
          this.deepthinkType = newVal
          if (this.deepthinkType) {
            this.deepthinkImg = require('@/assets/deepthink-select.png')
          } else {
            this.deepthinkImg = require('@/assets/deepthink.png')
          }
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="less">
.chat-bot-input-cpn {
  position: relative;
  width: 800px;
  margin: 0px auto;

  .input-area {
    z-index: 1;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 20px;
    display: flex;
    overflow: hidden;
    background-color: #fff;
    border-radius: 12px;
    .textarea-area {
      margin: 0 4px;
      width: 100%;
      max-height: calc(12 * 28px);
      margin: 0 4px;
      .chat-textarea {
        background-color: transparent;
        word-break: break-word;
        white-space: pre-wrap;
        border: none;
        width: 100%;
        margin: 0;
        padding: 5px;
        font-family: inherit;
        display: block;
        overflow: auto;
      }
    }
    .function-area {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      .deepseek-btn {
        border: 1px solid #d9d9d9;
        border-radius: 20px;
        padding: 5px 20px;
        cursor: pointer;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-right: 5px;
        }
      }
      .deepseek-btn.selected {
        color: #2f4eff;
        background-color: #deeafd;
        border-color: #bcd4ff;
      }
      .deepseek-btn.selected:hover {
        color: #2f4eff;
        background-color: #cde0ff;
        border-color: #89b4ff;
      }
      .send-btn {
        margin-right: 20px;
        cursor: pointer;
        .icon-fasong {
          font-size: 24px;
          color: #2f4eff;
        }
      }
      .stop-btn {
        background-color: #2f4eff;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .stop-icon {
          width: 12px;
          height: 12px;
          background-color: #fff;
          border-radius: 3px;
        }
      }
    }
  }
  .chat-help {
    z-index: 99;
  }
}
.chat-bot-input-cpn.disabled {
  cursor: not-allowed;
  textarea {
    cursor: not-allowed;
  }
  .deepseek-btn {
    cursor: not-allowed !important;
  }
}
</style>
